import React from 'react';
import { useTranslation } from 'react-i18next';
import ImageLink from '../../../components/link/ImageLink';
import { useTracking } from '../../../utils/tracking/TrackingContext';

interface TopicLayerSettingsCommandsProps {
  metadataUrl: string | undefined;
  downloadUrl: string | undefined;
}

const TopicLayerSettingsCommands = ({
  metadataUrl,
  downloadUrl,
}: TopicLayerSettingsCommandsProps) => {
  const { Tracking } = useTracking();
  const { t } = useTranslation('agisviewer');
  return (
    <div className="topic-layer__item-settings-commands">
      <ImageLink
        image="file-pdf"
        disabled={!metadataUrl}
        linkUrl={metadataUrl || ''}
        toolTip={
          metadataUrl
            ? t('topiclayersettings_documentation_tooltip')
            : t('topiclayersettings_documentation_unavailable')
        }
        clicked={() => Tracking.Topics.openMetadataUrl(metadataUrl)}
      />
      <ImageLink
        image="redirect-link"
        disabled={!downloadUrl}
        linkUrl={downloadUrl || ''}
        toolTip={
          downloadUrl
            ? t('topiclayersettings_download_tooltip')
            : t('topiclayersettings_download_unavailable')
        }
        clicked={() => Tracking.Topics.openGeodataUrl(downloadUrl)}
      />
    </div>
  );
};

export default TopicLayerSettingsCommands;
